import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/lantern/team/init', method: 'GET', params }, { interceptResultCode: false });
};

// 点击预约
export const appointAPI = (params) => {
  return axios({ url: '/lantern/team/book', method: 'POST', params }, { interceptResultCode: false });
};
// 点击领取奖励
export const getAPI = (params) => {
  return axios({ url: '/lantern/team/book/reward', method: 'POST', params }, { interceptResultCode: false });
};
// 开启任务
export const teamOpen = (params) => {
  return axios({ url: '/lantern/team/open', method: 'POST', params }, { interceptResultCode: false });
};

// 加入队伍初始化
export const inviteTeamInit = (params) => {
  return axios({ url: '/lantern/team/help', method: 'GET', params }, { interceptResultCode: false });
};

// 点击签到
export const signAPI = (params) => {
  return axios({ url: '/snail/five/sign', method: 'POST', params }, { interceptResultCode: false });
};

// 查询新服角色
export const topicShow = (params) => {
  return axios({ url: '/snail/topic/show', method: 'POST', params }, { interceptResultCode: false });
};

// 加入队伍
export const invite = (params) => {
  return axios({ url: '/lantern/team/entry', method: 'POST', params }, { interceptResultCode: false });
};
// 组队链接初始化
export const teamInit = (params) => {
  return axios({ url: '/snail/topic/help', method: 'GET', params }, { interceptResultCode: false });
};
// 领取奖励
export const reward = (params) => {
  return axios({ url: '/lantern/team/reward', method: 'POST', params }, { interceptResultCode: false });
};
// 一键领取组队奖励
export const teamReward = (params) => {
  return axios({ url: '/snail/topic/team/reward', method: 'POST', params }, { interceptResultCode: false });
};

// 免密登录
export const secretFreeLoginApi = (data) => {
  return axios({ url: '/cherry/auth/login', method: 'POST', data }, { interceptResultCode: false });
};

// 召回初始化
export const recallInitAPI = (params) => {
  return axios({ url: '/snail/five/invite', method: 'GET', params }, { interceptResultCode: false });
};

// 召回 绑定队友
export const recallBindPlayerAPI = (data) => {
  return axios({ url: '/snail/five/invite/entry', method: 'POST', data }, { interceptResultCode: false });
}

// 组队 初始化
export const teamInitAPI = (params) => {
  return axios({ url: '/snail/five/team', method: 'GET', params }, { interceptResultCode: false });
};

// 组队 加入队伍
export const teamJoinAPI = (data) => {
  return axios({ url: '/lantern/team/entry', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 踢出队伍
export const teamKickAPI = (data) => {
  return axios({ url: '/lantern/team/out', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 退出队伍
export const teamExitAPI = (data) => {
  return axios({ url: '/lantern/team/exit', method: 'POST', data }, { interceptResultCode: false });
};

// 组队 领取奖励
export const teamRewardAPI = (params) => {
  return axios({ url: '/lantern/team/reward', method: 'POST', params }, { interceptResultCode: false });
};

// 获取服务器时间
export const onGetTimeAPI = (params) => {
  return axios({ url: '/snail/web-activity', method: 'GET', params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/tideng/recall/api.js